import { View, StyleSheet, Text } from 'react-native';
import { theme } from '@/constants/theme';

export function KursiAvatar() {
  return (
    <View style={styles.container}>
      <View style={styles.imageContainer}>
        <Text style={styles.letter}>K</Text>
      </View>
      <View style={styles.ring} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 36,
    height: 36,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Force avatar to always sit on the right side regardless of layout direction
    alignSelf: 'flex-start',
    marginStart: 0,
    marginEnd: 8,
    flexShrink: 0,
  },
  imageContainer: {
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: 'rgba(142, 95, 255, 0.4)',
    borderRadius: 18,
    overflow: 'hidden',
    backgroundColor: theme.colors.primary,
    boxShadow: `0px 2px 6px ${theme.colors.primary}66`,
    elevation: 5,
    zIndex: 2,
  } as any,
  letter: {
    fontSize: 18,
    fontFamily: theme.fonts.bold,
    color: '#FFFFFF',
  },
  ring: {
    position: 'absolute',
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 2,
    borderColor: 'rgba(142, 95, 255, 0.2)',
    zIndex: 1,
  },
});